// test1590
(1590 && 0);
